// src/modules/manualJournal/api.js

import API from '../../services/api';

const BASE = '/manual-journal';

/* ── Daily Entries ── */

// Get all entries for a specific journal day
// Now uses query parameter instead of URL path
export const getDayEntries = (journalDate) => {
  return API.get(`${BASE}/entries`, { params: { journalDate } }).then((res) => res.data);
};

// Get daily summary
// Now uses query parameter instead of URL path
export const getDailySummary = (journalDate) => {
  return API.get(`${BASE}/summary`, { params: { journalDate } }).then((res) => res.data);
};

// Create a new transaction
// Now sends date and all data in the request body
export const createTransaction = (journalDate, data) => {
  const payload = { journalDate, ...data };
  return API.post(`${BASE}/transaction`, payload).then((res) => res.data);
};

// Update a transaction
export const updateTransaction = (transactionId, data) =>
  API.put(`${BASE}/transaction/${transactionId}`, data).then((res) => res.data);

// Delete a transaction
export const deleteTransaction = (transactionId) =>
  API.delete(`${BASE}/transaction/${transactionId}`).then((res) => res.data);

// Update opening/closing balance for a day
// Now sends journalDate and category in the request body instead of URL path
export const updateDayBalance = (journalDate, category, data) => {
  const payload = { journalDate, category, ...data };
  return API.post(`${BASE}/balance`, payload).then((res) => res.data);
};

// Finalize day entries
// Now sends journalDate in the request body instead of URL path
export const finalizeDayEntries = (journalDate) => {
  return API.post(`${BASE}/finalize`, { journalDate }).then((res) => res.data);
};

/* ── Reports ── */

// Get monthly report
export const getMonthlyReport = (monthYear) =>
  API.get(`${BASE}/reports/monthly/${monthYear}`).then((res) => res.data);

// Get account ledger
export const getAccountLedger = (category, params) =>
  API.get(`${BASE}/reports/ledger/${category}`, { params }).then((res) => res.data);

// Get cash flow statement
export const getCashFlowStatement = (params) =>
  API.get(`${BASE}/reports/cash-flow`, { params }).then((res) => res.data);

// Get reconciliation data
export const getReconciliationData = (category, params) =>
  API.get(`${BASE}/reports/reconciliation/${category}`, { params }).then((res) => res.data);
